module.exports = __webpack_public_path__ + "static/media/sort-circle-up.125e2285.svg";